export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 4_04.efe52813.jpg";